import React, { useState } from 'react';
import './CourseCardNew.scss';
import YCIcon from '../../../assets/images/Courses/thumbnail.png';

const CourseCardNew = ({ item, onClick, languageObject = {} }) => {
  const [colors] = useState([
    '#d4a373',
    '#f08080',
    '#a0c4ff',
    '#abc4ff',
    '#84dcc6',
    '#b388eb',
    '#a7bed3',
    '#e7cee3',
    '#e4b4c2',
    '#fcd29f',
    '#d2e0bf',
  ]);

  const isSubscribed =
    item.completed_percentage !== undefined && item.completed_percentage !== null;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const discountPercentage =
    item.course_price && item.discount_price
      ? Math.round(((item.course_price - item.discount_price) / item.course_price) * 100)
      : 0;

  return (
    <div role='button' onClick={onClick} className='course-card-new'>
      <div
        style={{ backgroundColor: colors[Math.floor(Math.random() * colors.length)] }}
        className='course-card-new__image-wrapper position-relative'
      >
        <img
          src={item.course_display_image || YCIcon}
          alt={item.course_title}
          className='course-card-new__image'
        />
        {item.bestseller_tag === 'true' && (
          <>
            {' '}
            {/* <div
              className='position-absolute w-100'
              style={{
                bottom: '0px',
                left: '0px',
                background:
                  'linear-gradient(0deg,rgba(0, 0, 0, 0.43) 0%, rgba(0, 0, 0, 0.26) 50%, rgba(0, 0, 0, 0) 100%)',
              }}
            /> */}
            <span style={{boxShadow: '1px 1px 8px -1px rgba(0,0,0,0.57)'}} className='course-card-new__badge bg-warning text-dark'>
              <i className='bi bi-star-fill me-1'></i>
              Bestseller
            </span>
          </>
        )}
      </div>

      <div
        style={Number(item.course_price) > 0 ? {} : { gap: '2.5px' }}
        className='course-card-new__content'
      >
        <h3 className='course-card-new__title text-left clampOn2Line'>{item.course_title}</h3>

        <div className='course-card-new__meta'>
          {/* Show progress bar if subscribed, language otherwise */}
          {isSubscribed ? (
            <div className='course-card-new__progress-wrapper'>
              <div className='course-card-new__progress-bar-track'>
                <div
                  className='course-card-new__progress-bar-fill'
                  style={{ width: `${item.completed_percentage}%` }}
                />
              </div>
              <span className='course-card-new__progress-label'>
                {item.completed_percentage}% {languageObject.completed || 'Completed'}
              </span>
            </div>
          ) : (
            item.language && (
              <span className='course-card-new__language bg-light text-dark'>
                <i className='bi bi-globe me-1'></i>
                {item.language?.split('~')?.join(', ')}
              </span>
            )
          )}

          {item.modified_at && (
            <span className='course-card-new__date text-muted'>
              <i className='bi bi-clock me-1'></i>
              Last Updated {formatDate(item.modified_at)}
            </span>
          )}
        </div>

        <div className='course-card-new__footer'>
          
            <div className='course-card-new__pricing'>
              <span className='course-card-new__price'>₹{item.discount_price}</span>
              {Boolean(item.course_price) && item.course_price != item.discount_price && (
                <span className='course-card-new__original-price text-muted'>
                  ₹{item.course_price}
                </span>
              )}
              {discountPercentage > 0 && (
                <span className='course-card-new__discount bg-success'>
                  {discountPercentage}% OFF
                </span>
              )}
            </div>
          

          {/* CTA Button */}
          {/* {isSubscribed ? (
            <button
              className='course-card-new__cta course-card-new__cta--continue'
              onClick={(e) => {
                e.stopPropagation();
                onClick && onClick();
              }}
            >
              <i className='bi bi-play-circle-fill me-1'></i>
              Continue Learning
            </button>
          ) : (
            <button
              className='course-card-new__cta course-card-new__cta--subscribe'
              onClick={(e) => {
                e.stopPropagation();
                onClick && onClick();
              }}
            >
              <i className='bi bi-bookmark-plus me-1'></i>
              Click to Subscribe
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default CourseCardNew;
